import { useEffect, useState } from "react";
import styles from "./TableTCU.module.css";
import TCUStyles from "../TCU.module.css";
import TCUVehiclePopover from "./TCUVehiclePopover";
import { DownloadIcon, ChevronDown, ChevronRight } from "lucide-react";
import { useTCUContextData } from "../Context";
import { downloadTCUVehicleData, getDepotWiseDataByCity, getLostTCUData } from "../../../../../services/cesl-bus/tcuService";
import { displayValue } from "../../../../Shared/common";
import ChartLoader from "../../../../Shared/Loader";

// bootstrap 4 + 5 attributes so the shared CustomModal opens either way (same as Device Health)
const MODAL_TRIGGER = {
    "data-toggle": "modal",
    "data-bs-toggle": "modal",
    "data-target": "#tcuVehicleDetails",
    "data-bs-target": "#tcuVehicleDetails"
};

const BUCKETS =[{ key: "<1", label: "<1" }, { key: "1", label: "1" }, { key: "2-5", label: "2-5" }, { key: "6-15", label: "6-15" }, { key: "16-30", label: "16-30" }, { key: "31-180", label: "31-180" }, { key: ">180", label: ">180" }];

export default function LostTCUAgeingTable({ title = "Lost TCU & Ageing", subtitle = "Depot-wise ageing bucket breakdown" }) {
    const { GlobalFilter } = useTCUContextData();
    const [selected, setSelected] = useState(null);
    const [selectedDepot, setSelectedDepot] = useState(null);
    const [lostTCUAndAgeingData, setLostTCUAndAgeing] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [bucketFilter, setBucketFilter] = useState("");
    const [openCity, setOpenCity] = useState(null);
    const [depotWiseTable, setDepotWiseTable] = useState({ data: [], loading: false })

    useEffect(() => {
        setIsLoading(true);
        getLostTCUData(GlobalFilter)
            .then(res => {
                setLostTCUAndAgeing(res?.cities || [])
                setOpenCity(null)
            })
            .catch(() => setLostTCUAndAgeing([]))
            .finally(() => setIsLoading(false));
    }, [GlobalFilter]);

    const handleBucketClick = (city, bucket, depot) => {
        setSelectedDepot(depot)
        setSelected(city);
        setBucketFilter(bucket);
    };

    // clickable depot cell: the data-* attributes open the modal (same as Device Health);
    // a zero count is disabled and gets neither the handler nor the trigger
    const depotCell = (city, depot, value, bucket, content) => {
        const clickable = value !== 0;
        return (
            <td
                className={`cursor-pointer ${clickable ? "" : "disabled"}`}
                {...(clickable ? MODAL_TRIGGER : {})}
                onClick={clickable ? () => handleBucketClick(city, bucket, depot.depot) : undefined}
            >
                {content}
            </td>
        );
    };

    const downloadVehicleData = () => {
        downloadTCUVehicleData(GlobalFilter).then(data => {
            const url = window.URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.download = "LostTCUandAgingVehicle.csv";
            link.click();
            window.URL.revokeObjectURL(url);
        }).catch(() => { });
    };

    function getDepotData(city) {
        setDepotWiseTable(prev => ({ ...prev, loading: true }))
        const isOpen = openCity === city;
        setOpenCity(isOpen ? null : city)
        getDepotWiseDataByCity({ ...GlobalFilter, city: [{ label: city, value: city }] })
            .then(res => setDepotWiseTable(prev => ({ ...prev, data: res?.depots || [], loading: false })))
            .catch(() => setDepotWiseTable(prev => ({ ...prev, data: [], loading: false })))
    }

    return (
        <>
            <div className={`card mx-3 shadow-sm ${styles.card}`}>
                <div className="card-body px-3 py-1">
                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-1">
                        <div className={TCUStyles.titleWrap}>
                            <span className={TCUStyles.titleBar} />
                            <span className={TCUStyles.title}>{title}</span>
                            <span className={TCUStyles.subtitle}>{subtitle}</span>
                        </div>
                        <span className="custom-Btn-animation" onClick={downloadVehicleData}><DownloadIcon size={15} /></span>
                    </div>

                    <div className={`table-responsive ${styles.tableWrapper}`}>
                        <table className={`table table-bordered table-hover align-middle mb-0 ${styles.mainTable}`}>
                            <thead className="sticky-top">
                                <tr>
                                    <th rowSpan={2}>City</th><th rowSpan={2}>Total Fleet</th><th rowSpan={2}>TCU Active</th><th rowSpan={2}>Lost TCU</th><th colSpan={BUCKETS.length}>Ageing Days</th>
                                </tr>
                                <tr>{BUCKETS.map(bucket => <th key={bucket.key}>{bucket.label}</th>)}</tr>
                            </thead>

                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan={11}><ChartLoader top="60%" /></td></tr>
                                ) : lostTCUAndAgeingData?.length ? (
                                    lostTCUAndAgeingData.map(item => {
                                        const city = item.city;
                                        const isOpen = openCity === city;
                                        return (
                                            <>
                                                <tr key={`city-${city}`} className={`${styles.cityRow} ${isOpen ? styles.cityRowActive : ""}`}>
                                                    <td className={`${styles.cityCell} cursor-pointer`} onClick={() => getDepotData(city)/* setOpenCity(isOpen ? null : city) */}>
                                                        <span className={styles.cityContent}>
                                                            <span className={styles.accordionIcon}>{isOpen ? <ChevronDown size={13} /> : <ChevronRight size={13} />}</span>
                                                            <span className={styles.cityName}>{displayValue(city)}</span>
                                                        </span>
                                                    </td>

                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} >{displayValue(item.total_vehicle)}</td>
                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} >{displayValue(item.tcu_activated)}</td>
                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} ><CountBadge value={item.lost_tcu} /></td>
                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} ><CountBadge value={item?.["<1"]} green /></td>
                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} ><CountBadge value={item?.["1"]} /></td>
                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} ><CountBadge value={item?.["2-5"]} /></td>
                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} ><CountBadge value={item?.["6-15"]} /></td>
                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} ><CountBadge value={item?.["16-30"]} /></td>
                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} ><CountBadge value={item?.["31-180"]} /></td>
                                                    <td className="cursor-pointer" onClick={() => getDepotData(city)} ><CountBadge value={item?.[">180"]} /></td>
                                                </tr>

                                                {isOpen &&
                                                    (depotWiseTable?.loading ? <tr><td colSpan={11}><div className="v-title"><div className="mb-0 no_data">Loading...</div></div></td></tr>
                                                        : depotWiseTable?.data.length ? depotWiseTable?.data?.map(depot => (
                                                            <tr key={`depot-${depot.id}`} className={`${styles.depotRow} cursor-pointer`}>
                                                                <td className={styles.depotName} {...MODAL_TRIGGER} onClick={() => handleBucketClick(city, "", depot.depot)}><span className={styles.depotIndicator} />{displayValue(depot.depot)}</td>
                                                                <td className="cursor-pointer" {...MODAL_TRIGGER} onClick={() => handleBucketClick(city, "", depot.depot)}>{displayValue(depot.total_vehicle)}</td>
                                                                {depotCell(city, depot, depot.tcu_activated, "lessThanOne", displayValue(depot.tcu_activated))}
                                                                {depotCell(city, depot, depot.lost_tcu, "greaterThanEqualToOne", <CountBadge value={depot.lost_tcu} />)}
                                                                {depotCell(city, depot, depot?.["<1"], "lessThanOne", <CountBadge value={depot?.["<1"]} green />)}
                                                                {depotCell(city, depot, depot?.["1"], "one", <CountBadge value={depot?.["1"]} />)}
                                                                {depotCell(city, depot, depot?.["2-5"], "twoToFive", <CountBadge value={depot?.["2-5"]} />)}
                                                                {depotCell(city, depot, depot?.["6-15"], "sixToFifteen", <CountBadge value={depot?.["6-15"]} />)}
                                                                {depotCell(city, depot, depot?.["16-30"], "sixteenToThirty", <CountBadge value={depot?.["16-30"]} />)}
                                                                {depotCell(city, depot, depot?.["31-180"], "thirtyOneToOneEighty", <CountBadge value={depot?.["31-180"]} />)}
                                                                {depotCell(city, depot, depot?.[">180"], "greaterThanOneEighty", <CountBadge value={depot?.[">180"]} />)}
                                                            </tr>
                                                        ))
                                                            : isOpen ? <>
                                                                <tr><td colSpan={11}><div className="v-title"><div className="alert alert-danger mb-0 no_data">Records not found</div></div></td></tr>
                                                            </> : <></>)}
                                            </>
                                        );
                                    })
                                ) : (
                                    <tr><td colSpan={11}><div className="v-title"><div className="alert alert-danger no_data">Records not found</div></div></td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {lostTCUAndAgeingData.length ? <small className={`d-block mt-1 ${styles.hint}`}>Click city to view depots. Click ageing count to view vehicle details.</small> : null}
                </div>
            </div>

            <TCUVehiclePopover selectedCity={selected} selectedDepot={selectedDepot} bucketFilter={bucketFilter} />
        </>
    );
}

function CountBadge({ value, green = false }) {
    return value ? <span className={`${styles.countBadge} ${green ? styles.greenBadge : styles.redBadge}`}>{value}</span> : <span className={styles.zeroValue}>0</span>;
}